const MARKDOWN_SYNTAX = /(^|\s)(#{1,6}|[-*+]>?|\d+\.)\s|[*_~`>[\]()!]/g;

export function getNodeSearchLabel(node) {
  const text = typeof node?.text === 'string' ? node.text : '';
  const withoutMarkdown = text.replace(MARKDOWN_SYNTAX, ' ').replace(/\s+/g, ' ').trim();
  return withoutMarkdown || node?.linkMeta?.title || node?.linkUrl || 'Untitled node';
}

function normalize(value) {
  return String(value || '').normalize('NFKD').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
}

function scoreField(value, query) {
  if (!value) return null;
  if (value === query) return 0;
  if (value.startsWith(query)) return 1;
  if (value.split(/[^\p{L}\p{N}]+/u).some((word) => word.startsWith(query))) return 2;
  const index = value.indexOf(query);
  return index === -1 ? null : 3 + Math.min(index / 1000, 0.9);
}

export function searchNodes(nodes, rawQuery, limit = 8) {
  const query = normalize(rawQuery);
  if (!query) return [];

  return (nodes || [])
    .map((node, sourceIndex) => {
      const label = getNodeSearchLabel(node);
      const fields = [
        [normalize(node?.text), 0],
        [normalize(node?.linkMeta?.title), 10],
        [normalize(node?.linkMeta?.description), 20],
        [normalize(node?.linkUrl), 30],
      ];
      const scores = fields
        .map(([value, weight]) => {
          const fieldScore = scoreField(value, query);
          return fieldScore === null ? null : fieldScore + weight;
        })
        .filter((score) => score !== null);
      if (!scores.length || !node?.id) return null;
      return {
        node,
        label,
        score: Math.min(...scores),
        sourceIndex,
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.score - b.score || a.sourceIndex - b.sourceIndex)
    .slice(0, Math.max(0, limit));
}
